import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/ui/cn";

type NoticeTone = "accent" | "ok" | "warn" | "danger";

const LOOK: Record<NoticeTone, string> = {
  accent: "border-accent/30 bg-accent-soft text-ink-2 [&>svg]:text-accent",
  ok: "border-ok/30 bg-ok-soft text-ink-2 [&>svg]:text-ok",
  warn: "border-warn/30 bg-warn-soft text-ink-2 [&>svg]:text-warn",
  danger: "border-danger/30 bg-danger-soft text-danger",
};
const ICON = { accent: Info, ok: CircleCheck, warn: TriangleAlert, danger: CircleAlert };

/** A one-line message in a tinted box. `danger` is announced as an alert. */
export function Notice({
  tone = "accent",
  className,
  children,
}: {
  tone?: NoticeTone;
  className?: string;
  children: ReactNode;
}) {
  const Icon = ICON[tone];
  return (
    <div
      role={tone === "danger" ? "alert" : "note"}
      className={cn(
        "flex items-start gap-2 rounded-lg border px-3 py-2.5 text-sm",
        LOOK[tone],
        className,
      )}
    >
      <Icon aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
